import { render, staticRenderFns } from "./approvel-refuse-result.vue?vue&type=template&id=30e8a4b0&scoped=true"
import script from "./approvel-refuse-result.vue?vue&type=script&lang=js"
export * from "./approvel-refuse-result.vue?vue&type=script&lang=js"
import style0 from "./approvel-refuse-result.vue?vue&type=style&index=0&id=30e8a4b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e8a4b0",
  null
  
)

export default component.exports